export default "/images/vendor/@coreui/icons/svg/flag/cif-rw.svg?b0af673860371e859ca7b2bb3a9d9870";